module.exports = __webpack_public_path__ + "images/740d7836.pay_9_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipintro/pay_9_kor.png
// module id = 581
// module chunks = 0